<template>
<div class="cards">
  <div class="boxsh">
    <div class="flexrow_green mt20">
      <div class="subheader_green_flex">
        <h2>Member Info</h2>
      </div>
      <div class="flexcircle">

        <!-- <a @click="$router.go(-1)" class="btn btn-gray btn-subheader">Back</a> -->
        <router-link to="/members" class="btn btn-gray btn-subheader gray">Back</router-link>
        <!-- <button type="button" class="btn btn-vermilion btn-subheader">Add Physician</button> -->
      </div>
    </div>
    <div class="cardinner">
      <div class="row ">
        <div class="col-sm-4 mb20">
          <label> First Name:</label>
          <span class="spanblock">{{admininfo.first_name}}</span>
        </div>
        <div class="col-sm-4 mb20">
          <label> Last Name:</label>
          <span class="spanblock">{{admininfo.last_name}}</span>
        </div>
        <div class="col-sm-4 mb20 wwrap">
          <label>Email:</label>
          <span class="spanblock">{{admininfo.email}}</span>
        </div>

        <div class="col-sm-4 mb20">
          <label>Phone Number</label>
          <span class="spanblock">{{admininfo.phone}}</span>
        </div>
        <div class="col-sm-4 mb20">
          <label>User ID</label>
          <span class="spanblock">{{admininfo.username}}</span>
        </div>
        <div class="col-sm-12 mb20">
          <label>Address:</label>
          <span class="spanblock">{{admininfo.address}}</span>

        </div>
        <div class="col-sm-12 text-center mb20" style="color: #da6c41">
            <h6>Store Info</h6>
        </div>

          <div class="col-sm-4 mb20">
            <label>Store Name:</label>
            <span class="spanblock">{{storeinfo.store_name}}</span>
          </div>
          <div class="col-sm-4 mb20">
            <label>Domain Name:</label>
            <span class="spanblock">{{storeinfo.url}}</span>
          </div>
          <div class="col-sm-4 mb20 wwrap" v-if="storeinfo.store_email !== null">
            <label>Email:</label>
            <span class="spanblock">{{storeinfo.store_email}}</span>
          </div>

          <div class="col-sm-4 mb20"  v-if="storeinfo.store_phone !== null">
            <label>Phone Number</label>
            <span class="spanblock">{{storeinfo.store_phone}}</span>
          </div>
           <div class="col-sm-4 mb20" v-if="storeinfo.payoption !== null">
            <label>Payment Option</label>
            <span class="spanblock">{{storeinfo.payoption}}</span>
          </div>
          <div class="col-sm-4 mb20" v-if="storeinfo.shippingtype !== null">
            <label>Shipping Type</label>
            <span class="spanblock">{{storeinfo.shippingtype}}</span>
          </div>
          <div class="col-sm-12 mb20 wwrap" v-if="storeinfo.purchasetype !== null">
            <label>Purchase Type</label>
            <span class="spanblock">{{storeinfo.purchasetype}}</span>
          </div>
          <!-- <div class="col-sm-12 mb20 wwrap">
            <label>Store Address:</label>
            <span class="spanblock" v-html="storeinfo.store_address"></span>
          </div> -->

          <div class="hrline" ></div>
          <div class="col-12">
            <div class="onebox mb10 ">
              <label class="profile1">
                <img v-if="storeinfo.store_logo == null"  src="@/assets/images/logodefault.png" class="asp_imgp img-fluid"   style="width:100%;height:100%" alt="">
                <img class="asp_imgp img-fluid"  v-if="storeinfo.store_logo != null " :src="`${$imageUrl}` +storeinfo.store_logo"  style="margin-bottom:10px; width:100%; height:100%" alt="">
              </label>
          </div>
        </div>

        <div class="col-sm-12 mb20" v-if="roles !== '' && roles.length != 0">
          <label>The Vendor Can Acces Following Features: </label>
          <div class="featureblock">
            <span class="spanblock" v-if="roles.products == 'true'">Products </span>
            <span class="spanblock" v-if="roles.category == 'true'">Category</span>
            <span class="spanblock" v-if="roles.brands == 'true'">Brands</span>
            <span class="spanblock" v-if="roles.pages == 'true'">Pages</span>
            <span class="spanblock" v-if="roles.banners == 'true'">Banner</span>
            <span class="spanblock" v-if="roles.blogs == 'true'">Blogs</span>
            <span class="spanblock" v-if="roles.roles == 'true'">Roles</span>
            <span class="spanblock" v-if="roles.menus == 'true'">Menu</span>
            <span class="spanblock" v-if="roles.seo == 'true'">SEO</span>
            <span class="spanblock" v-if="roles.social == 'true'">Social</span>
          </div>

        </div>

        <div class="hrline" ></div>
        <div class="col-12 text-right">
          <button type="button" class="btn btn-green" name="button" v-on:click="activate(admininfo)" v-if="admininfo.status === 'suspend'">Activate</button>
          <button type="button" class="btn btn-vermilion" name="button" v-on:click="suspend(admininfo)" v-if="admininfo.status === 'active'">Suspend</button>

          <router-link :to="{ name: 'editmember', params: { eid: admininfo.reg_id }}"  class="btn btn-vermilion">Edit Info</router-link>
          <router-link :to="{ name: 'editstore', params: { eid: admininfo.reg_id }}"  class="btn btn-vermilion">Edit Store Info</router-link>
          <router-link :to="{ name: 'member-dashboard', params: { mid: admininfo.userid}}"  class="btn btn-vermilion">Member Dashboard</router-link>
           
          <button v-if="roles.length == 0 " type="button" class="btn btn-green" name ="button" data-toggle="modal" data-target=".bd-example-modal-lg3">
             <font-awesome-icon icon="plus-circle"></font-awesome-icon> Add Features</button>
          <button v-if="roles.length != 0" type="button" class="btn btn-green" name ="button" data-toggle="modal" data-target=".bd-example-modal-lg3">Edit Features</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade bd-example-modal-lg3" id="addressmodal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel3" aria-hidden="true">
    <div class="modal-dialog modal-lg2">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle" v-if="roles.length == 0">Add Features</h5>
          <h5 class="modal-title" id="exampleModalLongTitle" v-if="roles !== '' && roles.length != 0">Update Features</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form v-on:submit.prevent="updatefeautres()">
            <div class="row">
              <div class="col-lg-4 col-md-4">
                  <div class="row cmnrb">
                    <div class="col-lg-8">
                      <label for="park">Products</label>
                    </div>
                    <div class="col-lg-4">
                      <label class="switch">
                         <input type="checkbox"  true-value="true" false-value="false" v-model="feature.products">
                         <span class="slider round"></span>
                       </label>
                    </div>
                   </div>
              </div>
              <div class="col-lg-4 col-md-4">
                  <div class="row cmnrb">
                    <div class="col-lg-8">
                        <label for="fence">Category</label>
                    </div>
                    <div class="col-lg-4">
                      <label class="switch">
                         <input type="checkbox"  true-value="true" false-value="false"  v-model="feature.category">
                         <span class="slider round"></span>
                       </label>
                    </div>
                   </div>
              </div>
              <div class="col-lg-4 col-md-4">
                  <div class="row cmnrb">
                    <div class="col-lg-8">
                      <label for="swater">Brands</label>
                    </div>
                    <div class="col-lg-4">
                      <label class="switch">
                         <input type="checkbox"  true-value="true" false-value="false"  v-model="feature.brands">
                         <span class="slider round"></span>
                       </label>
                    </div>
                   </div>
              </div>
            </div>
            <h6>CMS</h6>
            <div class="row">

              <div class="col-lg-4 col-md-4">
                  <div class="row cmnrb">
                    <div class="col-lg-8">
                      <label for="park">Pages</label>
                    </div>
                    <div class="col-lg-4">
                      <label class="switch">
                         <input type="checkbox"  true-value="true" false-value="false" v-model="feature.pages" >
                         <span class="slider round"></span>
                       </label>
                    </div>
                   </div>
              </div>
              <div class="col-lg-4 col-md-4">
                  <div class="row cmnrb">
                    <div class="col-lg-8">
                        <label for="fence">Banner</label>
                    </div>
                    <div class="col-lg-4">
                      <label class="switch">
                         <input type="checkbox"  true-value="true" false-value="false" v-model="feature.banners">
                         <span class="slider round"></span>
                       </label>
                    </div>
                   </div>
              </div>
              <div class="col-lg-4 col-md-4">
                  <div class="row cmnrb">
                    <div class="col-lg-8">
                        <label for="fence">Menu</label>
                    </div>
                    <div class="col-lg-4">
                      <label class="switch">
                         <input type="checkbox"  true-value="true" false-value="false" v-model="feature.menus">
                         <span class="slider round"></span>
                       </label>
                    </div>
                   </div>
              </div>
              <div class="col-lg-4 col-md-4">
                  <div class="row cmnrb">
                    <div class="col-lg-8">
                      <label for="park">Blogs</label>
                    </div>
                    <div class="col-lg-4">
                      <label class="switch">
                         <input type="checkbox"  true-value="true" false-value="false" v-model="feature.blogs" >
                         <span class="slider round"></span>
                       </label>
                    </div>
                   </div>
              </div>
            </div>
              <h6>Settings</h6>
            <div class="row">

              <div class="col-lg-4 col-md-4">
                  <div class="row cmnrb">
                    <div class="col-lg-8">
                      <label for="park">Role</label>
                    </div>
                    <div class="col-lg-4">
                      <label class="switch">
                         <input type="checkbox"  true-value="true" false-value="false" v-model="feature.roles" >
                         <span class="slider round"></span>
                       </label>
                    </div>
                   </div>
              </div>
              <div class="col-lg-4 col-md-4">
                  <div class="row cmnrb">
                    <div class="col-lg-8">
                        <label for="fence">SEO</label>
                    </div>
                    <div class="col-lg-4">
                      <label class="switch">
                         <input type="checkbox"  true-value="true" false-value="false"  v-model="feature.seo">
                         <span class="slider round"></span>
                       </label>
                    </div>
                   </div>
              </div>
              <div class="col-lg-4 col-md-4">
                  <div class="row cmnrb">
                    <div class="col-lg-8">
                      <label for="swater">Social</label>
                    </div>
                    <div class="col-lg-4">
                      <label class="switch">
                         <input type="checkbox"  true-value="true" false-value="false" v-model="feature.social">
                         <span class="slider round"></span>
                       </label>
                    </div>
                   </div>
              </div>
            </div>

            <div class="row mar-t-50">
              <div class="col-lg-12 text-center">
                <button type="submit" class="cart btn btn-vermilion">Submit</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
  import _ from 'lodash';
  import $ from 'jquery'
export default {
  name: 'member_info',
  data () {
    return {
      error: false,
      errorreport: '',
      admininfo: {
      },
      storeinfo: {},
      roles: [],
      status: '',
      postImageUrl: '',
      feature: {
        products: false,
        category: false,
        brands: false,
        pages: false,
        banner: false,
        menus: false,
        roles: false,
        seo: false,
        social: false,
        blogs: false
      }
    }
  },
  mounted () {
    this.getadmininfoo()
    this.storeinfoo()
    this.getroles()
  },
  methods: {
    getadmininfoo () {
      this.$http.get('/register/getadmininfo/' + this.$route.params.id).then((res) => {
        if (res.data.success === true) {
          this.admininfo = res.data.details[0]
        }
      })
    },
    storeinfoo () {
      this.$http.get('/register/getstoreinfo/' + this.$route.params.id).then((res) => {
        if (res.data.success === true) {
          this.storeinfo = res.data.details[0]
        }
      })
    },
    getroles () {
      this.$http.get('/register/getroles/' + this.$route.params.id).then((res) => {
        if (res.data.success === true) {
          if(res.data.details.length != 0) {
            this.roles = res.data.details[0]
            this.feature = res.data.details[0]
          }
        }
      })
    },
    uploadChange ($event) {
      this.convertBase64($event.target)
    },
    convertBase64 (inputValue) {
      const file = inputValue.files[0]
      this.files.push({filee: file})
      const myReader = new FileReader()
      myReader.onloadend = (e) => {
        this.postImageUrl = myReader.result
        this.ImageUrl = myReader.result
      }
      myReader.readAsDataURL(file)
    },

    // For suspend the Channel Partner...
      suspend (cpat) {
        let message = "Are you sure you want to suspend " + cpat.first_name + " " + cpat.last_name +'?'
        this.$dialog.confirm(message,{
          loader: true,
          okText: "Proceed",
          cancelText: "Cancel"
        })
        .then((dialog) => {
          this.$http.put('/register/updatestatus/' + cpat.reg_id, {
            status: "suspend"
          }).then((res) => {
         if(res.data.success === true) {
            // this.loadinfo()
            this.getadmininfoo()
            this.storeinfoo()
            this.getroles()
            dialog.close()
            }
          })
        })
        .catch(() => {
          //console.log(this.$i18n.t('dataarray.xa271'))
        })
      },

    // For activate the Channel Partner...
    activate (cpat) {
      let message = "Are you sure you want to Activate " + cpat.first_name + " " + cpat.last_name +'?'
      this.$dialog.confirm(message,{
        loader: true,
        okText: "Proceed",
        cancelText: "Cancel"
      })
      .then((dialog) => {
        this.$http.put('/register/updatestatus/' + cpat.reg_id, {
          status: "active"
        }).then((res) => {
          if(res.data.success === true) {
            // this.loadinfo()
          this.getadmininfoo()
          this.storeinfoo()
          this.getroles()
          dialog.close()
          }
        })
      })
      .catch(() => {
      })
    },
    updatefeautres () {
      console.log(this.feature)
      this.$http.put('/features/updatefeatures/' + this.$route.params.id, this.feature).then((res) => {
        if (res.data.success === true) {
          this.getroles()
          $('#addressmodal').modal('hide')
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/member-info.vue